import React from 'react';
import { copyToClipboard } from '@/utils/copy';
import { toastUtils } from '@/utils/toast';
import { useTranslations } from 'next-intl';
import IconFont from '@/components/ui/iconFont';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  copyValue?: string; // 用于复制的完整值，如果不提供则使用 value
  showCopy?: boolean;
  onCopy?: () => void;
  explorerUrl?: string; // 区块链浏览器链接，如果提供则支持点击跳转
  valueClassName?: string; // 自定义 value 的 className
}

const DetailRow = ({ label, value, copyValue, showCopy = false, onCopy, explorerUrl, valueClassName }: DetailRowProps) => {
  const t = useTranslations('referral');

  const handleCopy = async () => {
    const valueToCopy = copyValue || (typeof value === 'string' ? value : '');
    if (!valueToCopy || valueToCopy === '0') return;
    try {
      await copyToClipboard(valueToCopy);
      toastUtils.copySuccess(t('copySuccess'));
      onCopy?.();
    } catch (err) {
      console.error('Failed to copy text: ', err);
      toastUtils.copyError();
    }
  };

  const handleExplorerClick = () => {
    if (explorerUrl) {
      window.open(explorerUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="flex justify-between items-center w-full leading-[20px]">
      <span className="text-tertiary text-[12px] font-medium">{label}</span>
      <div className="flex items-center space-x-[5px]">
        <span
          className={`text-secondary text-[12px] font-medium ${explorerUrl ? 'cursor-pointer hover:text-white transition-colors underline' : ''} ${valueClassName || ''}`}
          onClick={explorerUrl ? handleExplorerClick : undefined}
        >
          {value}
        </span>
        {showCopy && (
          <button
            onClick={handleCopy}
            disabled={!copyValue && (typeof value !== 'string' || !value || value === '0')}
            className={`disabled:opacity-50 disabled:cursor-not-allowed ${!copyValue && (typeof value !== 'string' || !value || value === '0') ? '' : 'active:scale-90'}`}
          >
            <IconFont name='copy' size={10} />
          </button>
        )}
      </div>
    </div >
  );
};

export default DetailRow;